export const visit = (vm, at) => {
at({ "it": { "conversationsVisitorUIAvailability": { "sameDay": "Torneremo oggi alle ore {{time}}", "nextDay": "Torneremo domani alle ore {{time}}", "nextWeek": "Torneremo {{dayOfWeek}} alle ore {{time}}" } } });
};